import moment from "moment";
import "moment-timezone";

export const FORMATTED_TODAY_DATE_YYYYMMDD = moment()
  .tz("Asia/Kolkata")
  .format("YYYY-MM-DD");

export const isSunday = (date) => {
  return date.getDay() === 0;
};

export const startOfTheMonth = moment()
  .tz("Asia/Kolkata")
  .startOf("month")
  .subtract(90, "days")
  .format("YYYY-MM-DD");

export const currentDateOfTheMonth = moment()
  .tz("Asia/Kolkata")
  .format("YYYY-MM-DD");
export const TODAYS_DATE_FORMATTED = moment()
  .tz("Asia/Kolkata")
  .format("DD-MM-YYYY");

export const currentYear = moment().tz("Asia/Kolkata").format("YYYY");
export const currentMonthNumber = moment().tz("Asia/Kolkata").month() + 1;
export const currentMonthName = moment().tz("Asia/Kolkata").format("MMMM");
const nextMonthEndDate = moment()
  .tz("Asia/Kolkata")
  .add(1, "months")
  .endOf("month");

const today = moment().tz("Asia/Kolkata");
const startDate = moment().tz("Asia/Kolkata").startOf("month");
const endDate = moment().tz("Asia/Kolkata");
const monthEndDate = moment().tz("Asia/Kolkata").endOf("month");
const tomorrowDate = moment().tz("Asia/Kolkata").add(1, "days");
const yesterdayDate = moment().tz("Asia/Kolkata").subtract(1, "days");
export const currentMonthStartDate = startDate.format("YYYY-MM-DD");
export const currentMonthCurrentDate = endDate.format("YYYY-MM-DD");
export const currentMonthEndDate = monthEndDate.format("YYYY-MM-DD");
export const currentMonthTomorrowDate = tomorrowDate.format("YYYY-MM-DD");
export const currentMonthYesterdayDate = yesterdayDate.format("YYYY-MM-DD");
export const nextMonthEndDateFormatted = nextMonthEndDate.format("YYYY-MM-DD");

export const IS_LAST_DAY_OF_THE_MONTH =
  currentMonthTomorrowDate ===
  moment()
    .tz("Asia/Kolkata")
    .add(1, "days")
    .startOf("month")
    .format("YYYY-MM-DD");

export const getMonthName = (monthNumber) => {
  return moment()
    .tz("Asia/Kolkata")
    .month(monthNumber - 1)
    .format("MMMM");
};

export const formattedToday = today.format("YYYY-MM-DD");
export const formattedTodayDisplay = today.format("DD-MM-YYYY");

export const startOfMonth = today.startOf("month").format("DD-MM-YYYY");
export const endOfMonth = today.endOf("month").format("DD-MM-YYYY");
export const todayFormatted = today.format("DD-MM-YYYY");

const tomorrow = moment().tz("Asia/Kolkata").add(1, "day");
export const minDate = {
  startDate: tomorrow.toDate(),
  endDate: tomorrow.toDate(),
};

export const convertTime = (time) => {
  return time ? moment(time, "HH:mm").tz("Asia/Kolkata").format("h:mm A") : "-";
};

export const converSlot = (times) => {
  const timeSlots = times.split("-");
  const convertedSlots = timeSlots.map((slot) => {
    const [hours, minutes] = slot.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const hour = hours % 12 || 12;
    return `${hour}:${minutes < 10 ? "0" : ""}${minutes} ${period}`;
  });

  return convertedSlots.join(" - ");
};

export const convertTimeRange = (timeRange) => {
  if (!timeRange) return "-";

  const [startTime, endTime] = timeRange.split("-");

  const formattedStartTime = startTime
    ? moment(startTime, "HH:mm").tz("Asia/Kolkata").format("h:mm A")
    : "";
  const formattedEndTime = endTime
    ? moment(endTime, "HH:mm").tz("Asia/Kolkata").format("h:mm A")
    : "";

  return formattedStartTime && formattedEndTime
    ? `${formattedStartTime}-${formattedEndTime}`
    : "-";
};

export const convertTimeHHMMSS = (time) => {
  if (!time) return "-";

  const formattedTime = moment(time, "HH:mm")
    .tz("Asia/Kolkata")
    .format("h:mm A");

  return formattedTime || "-";
};

export const convertTo24HourFormat = (time) => {
  if (!time) return "";

  const [hourString, minuteString, period] = time.split(/\s|:/);
  const hour = parseInt(hourString);
  const minute = parseInt(minuteString);

  let formattedHour = hour;
  if (period === "PM" && hour !== 12) {
    formattedHour += 12;
  } else if (period === "AM" && hour === 12) {
    formattedHour = 0;
  }

  const formattedTime = `${formattedHour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")}`;

  return formattedTime;
};

export const formattedLongDate = (timestamp) =>
  timestamp
    ? moment.unix(timestamp).tz("Asia/Kolkata").format("DD-MM-YYYY")
    : "-";

export const formattedLongDate1 = (timestamp) =>
  timestamp
    ? moment(timestamp / 1000)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY")
    : "-";

export const formattedLongDate2 = (timestamp) => {
  if (!timestamp) {
    return "-";
  }

  const parsedTimestamp =
    typeof timestamp === "string" ? parseInt(timestamp, 10) : timestamp;

  if (isNaN(parsedTimestamp)) {
    return "-";
  }

  return moment(parsedTimestamp).tz("Asia/Kolkata").format("DD-MM-YYYY");
};

export const convertUnixTimestampToDate = (timestamp) => {
  const date = new Date(parseInt(timestamp, 10));
  return moment(date).tz("Asia/Kolkata").format("DD-MM-YYYY");
};

export const isDateToday = (dateString) => {
  const date = moment(dateString).tz("Asia/Kolkata");
  const today = moment().tz("Asia/Kolkata");
  return date.isSame(today, "day");
};

export const convertTxtFromHtml = (content) =>
  content.replace(/(<([^>]+)>)/gi, "");

export const formattedAmount = (amount) =>
  amount
    ? amount.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
      })
    : 0;

export const convertThenFormat = (amount) => {
  const convertedAmount = parseFloat(amount || 0);
  const formattedAmount = convertedAmount
    ? convertedAmount.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
      })
    : 0;

  return formattedAmount;
};

export const convertThenFormat1 = (amount) => {
  const convertedAmount = parseFloat(amount || 0);
  const formattedAmount = convertedAmount
    ? convertedAmount.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";

  return formattedAmount;
};

export const getMonthYear = (date) => {
  if (!date) return "";

  const m = moment.tz(date, "Asia/Kolkata");
  if (!m.isValid()) return "";

  return m.format("MMMM YYYY");
};

export const getMonthYearFromYYMM = (date) => {
  if (!date) return "";

  const m = moment.tz(date, "Asia/Kolkata");
  if (!m.isValid()) return "";

  return m.format("MMMM YYYY");
};

export const getMonthYearFromYYYYMM = (date) => {
  if (!date) return "";
  const m = moment.tz(date, "YYYY-MM", "Asia/Kolkata");
  if (!m.isValid()) return "";
  return m.format("MMMM YYYY");
};

export const getFirstDateOfMonthFromYYYYMM = (date) => {
  if (!date) return "";
  const m = moment.tz(date, "YYYY-MM", "Asia/Kolkata");
  if (!m.isValid()) return "";
  return m.startOf("month").format("YYYY-MM-DD");
};

export const generateDurationOptions = (duration) => {
  const options = [];
  let start = 1;
  while (start <= duration) {
    const end = Math.min(start + 6, duration);
    const label = `${start}-${end}`;
    const value = end - start + 1;
    options.push({ value, label });
    start += 7;
  }
  return options;
};

export const fixedTwo = (value) => {
  return parseFloat(value || 0)?.toFixed(2);
};

export const formatTimezoneThenStraight = (date) =>
  date ? moment(date).tz("Asia/Kolkata").format("DD MMMM YYYY hh:mm A") : "-";

export const isDateExpired = (date) => {
  if (date) {
    const momentDate = moment(date).tz("Asia/Kolkata");
    return momentDate.isValid() ? momentDate.isSameOrBefore(today) : false;
  }
  return false;
};

export function convertTimeRangeHHMMSS(timeString) {
  if (!timeString) return "";

  const [hours, minutes, seconds] = timeString.split(":");

  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(seconds);

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return formattedTime;
}

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();

  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;

  return `${year}-${month}-${day}`;
};

export const formatDateAndTime = (dateString) => {
  if (dateString) {
    const dateTime = moment(dateString, "YYYY-MM-DD HH:mm:ss").tz(
      "Asia/Kolkata"
    );

    const formattedDate = dateTime.format("DD-MM-YYYY");

    const formattedTime = dateTime.format("h:mm A");

    return { formattedDate, formattedTime };
  } else return {};
};

export const formatDateTimezon = (dateString) => {
  const formattedDate = moment(dateString)
    .tz("Asia/Kolkata")
    .format("DD-MM-YYYY");
  return formattedDate;
};

export const formatDateTimezonYYMMDD = (dateString) => {
  const formattedDate = moment(dateString)
    .tz("Asia/Kolkata")
    .format("YYYY-MM-DD");
  return formattedDate;
};

export const formatTimezoneThenStraight1 = (date) =>
  date ? moment(date).tz("Asia/Kolkata").format("DD-MM-YYYY") : "-";

export const convertToYYYYMMDD = (dateString) => {
  return dateString
    ? moment(dateString, "DD-MM-YYYYY").tz("Asia/Kolkata").format("YYYY-MM-DD")
    : "-";
};

export const convertStraight = (date) => {
  if (!date) return "-";
  const parsed = moment(
    date,
    ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601],
    false
  );
  return parsed.isValid()
    ? parsed.tz("Asia/Kolkata").format("DD-MM-YYYY")
    : "-";
};

export const formatDateTime = (datetime) => {
  if (!datetime) return "-";

  const isValidDatetime = moment(datetime, moment.ISO_8601, true).isValid();

  return isValidDatetime
    ? moment(datetime).tz("Asia/Kolkata").format("DD MMMM YYYY hh:mm A")
    : "-";
};

export const formatDateTimeFromReverseAnd24Hours = (datetime) => {
  return datetime
    ? moment(datetime, "YYYY-MM-DD HH:mm:ss")
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY, h:mm A")
    : "-";
};

export function dateFormatWithNaming(date) {
  const convertedDate = date
    ? moment(date).tz("Asia/Kolkata").format("DD MMMM YYYY")
    : "-";
  return convertedDate;
}

export function formatExtractDateTime(subscriptionAdded) {
  const date = new Date(subscriptionAdded);

  // Extract date in YYYY-MM-DD format
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  // Extract time in 24-hour format
  const hours24 = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const formattedTime24 = `${hours24}:${minutes}`;

  // Extract time in 12-hour format with AM/PM
  const hours12 = hours24 % 12 || 12;
  const period = hours24 < 12 ? "AM" : "PM";
  const formattedTime12 = `${hours12}:${minutes} ${period}`;

  return { formattedDate, formattedTime24, formattedTime12 };
}

export const convertTo12HourFormat = (time24) => {
  if (!time24) return "";

  const [hours, minutes] = time24.split(":");
  const period = +hours >= 12 ? "PM" : "AM";
  const hours12 = +hours % 12 || 12;
  return `${hours12}:${minutes} ${period}`;
};

export const formatDateFromStraightToComplex = (dateString) => {
  const date = moment(dateString, "DD-MM-YYYY");
  return date.format("Do MMMM YYYY, dddd");
};

export function getDayFromDate(dateInput) {
  let date;

  if (/^\d{2}-\d{2}-\d{4}$/.test(dateInput)) {
    date = moment.tz(dateInput, "DD-MM-YYYY", "Asia/Kolkata");
  } else {
    date = moment.tz(dateInput, "Asia/Kolkata");
  }

  if (!date.isValid()) {
    throw new Error("Invalid date format");
  }

  const dayOfWeek = date.format("dddd");

  return dayOfWeek;
}

export const getMaxDate = () => {
  const today = moment().tz("Asia/Kolkata");
  const tenYearsAgo = today.subtract(10, "years");
  return tenYearsAgo.format("YYYY-MM-DD");
};

export const getMinDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getMaxDateUptoLastMonthDate = () => {
  const currentDate = moment.tz("Asia/Kolkata");
  const lastDayOfCurrentMonth = currentDate.clone().endOf("month");

  const remainingDaysInMonth = lastDayOfCurrentMonth.diff(currentDate, "days");

  if (remainingDaysInMonth < 5) {
    return currentDate.clone().add(1, "month").startOf("month").add(6, "days");
  }

  return lastDayOfCurrentMonth;
};

export function convertTo24HourFormat1(time) {
  try {
    if (!time || typeof time !== "string") {
      throw new Error("Invalid time format");
    }

    let timeIn24Hour = moment(time, ["h:mm A", "HH:mm"]);
    if (!timeIn24Hour.isValid()) {
      throw new Error("Invalid time format");
    }

    return timeIn24Hour.tz("Asia/Kolkata").format("HH:mm");
  } catch (error) {
    console.error("Error in convertTo24HourFormatInKolkata:", error.message);
    return "";
  }
}

export const isMoreThan7DaysOld = (date) => {
  const now = moment().tz("Asia/Kolkata");
  const givenDate = moment(date).tz("Asia/Kolkata");
  const diffInDays = now.diff(givenDate, "days");

  return diffInDays > 7;
};

export const formatLakh = (num) => {
  if (!num) return "0";
  const n = parseFloat(num);
  if (isNaN(n)) return num;
  if (n >= 100000) return `₹ ${(n / 100000).toFixed(1)}L`;
  return `₹${n.toLocaleString("en-IN")}`;
};

export const formatTicketDate = (datetime) => {
  if (!datetime) return "-";

  const isValidDatetime = moment(datetime, moment.ISO_8601, true).isValid();
  if (!isValidDatetime) return "-";

  const date = moment(datetime).tz("Asia/Kolkata");
  const now = moment().tz("Asia/Kolkata");

  const diffMinutes = now.diff(date, "minutes");
  const diffHours = now.diff(date, "hours");
  const diffDays = now.diff(date, "days");

  if (diffDays >= 10) {
    // If more than 10 days ago, show full date
    return date.format("DD MMM YYYY");
  } else {
    // For recent updates, show more granular time differences
    if (diffMinutes < 60) {
      // Less than an hour ago
      return diffMinutes === 0
        ? "Just now"
        : diffMinutes === 1
        ? "1 minute ago"
        : `${diffMinutes} minutes ago`;
    } else if (diffHours < 24) {
      // Less than a day ago
      return diffHours === 1 ? "1 hour ago" : `${diffHours} hours ago`;
    } else {
      // Less than 10 days ago
      return diffDays === 0
        ? "Today"
        : diffDays === 1
        ? "Yesterday"
        : `${diffDays} days ago`;
    }
  }
};

export const convertTimeRangeTo12HourFormat = (timeRange) => {
  if (!timeRange) return "";

  const parts = timeRange.split(" - ");
  if (parts.length !== 2) return timeRange;
  return parts.map((t) => convertTo12HourFormat(t.trim())).join(" - ");
};

export const firstDateOfCurrentYearMonth = (month) => {
  if (!month) return null;

  const currentYear = new Date().getFullYear();
  const monthValue = month?.value || month;

  if (!monthValue) return null;

  return moment(`${currentYear}-${monthValue}-01`)
    .tz("Asia/Kolkata")
    .format("YYYY-M-DD");
};

export const formatDateToDisplay = (dateString) => {
  if (!dateString) return "-";
  return moment.tz(dateString, "Asia/Kolkata").format("ddd, MMM DD, YYYY");
};

export const date_format_wrong = (date) => {
  const formattedDate = new Date(+date * 1000).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const formattedTime = new Date(+date * 1000).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${formattedDate} 
       ${moment(formattedTime, "HH:mm").tz("Asia/Kolkata").format("hh:mm A")}`;
};

export const date_format_wrong_date = (date) => {
  const formattedDate = new Date(+date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const formattedTime = new Date(+date).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${formattedDate} 
       ${moment(formattedTime, "HH:mm").tz("Asia/Kolkata").format("hh:mm A")}`;
};